/** @jsx jsx */
import { Fragment } from 'react'
import { jsx } from '@emotion/core'

import Answer from './Answer'
import NextAnswer from './NextAnswer'

const Answers = ({
  id,
  index,
  answers,
  type,
  editAnswers,
  update,
  setEditAnswers,
  isTemplate,
  submitted,
}) => {
  const handleSubmit = (index) =>
    setEditAnswers([...editAnswers].filter((el) => el !== index))

  const handleDrop = (index) => {
    setEditAnswers([...editAnswers].filter((el) => el !== index))
    update(
      'answers',
      [...answers].filter((_, answerIndex) => answerIndex !== index)
    )
  }

  const onChange = (index, event) => {
    const newAnswers = [...answers]
    newAnswers[index] = event.target.value
    update('answers', newAnswers)
  }

  const handleEdit = (index) => setEditAnswers([...editAnswers, index])

  return (
    <Fragment>
      <div className="answers">
        {answers?.map((answer, i) => (
          <Answer
            key={`edit-answer-${id}-${i}`}
            type={type}
            isDraft={editAnswers.includes(i)}
            answer={answer}
            onChange={(e) => onChange(i, e)}
            handleEdit={() => handleEdit(i)}
            handleSubmit={() => handleSubmit(i)}
            handleDrop={() => handleDrop(i)}
            isTemplate={isTemplate}
          />
        ))}
      </div>
      {answers?.length < 8 && (
        <NextAnswer
          update={update}
          answers={answers}
          submitted={submitted}
          index={index}
        />
      )}
    </Fragment>
  )
}

export default Answers
